module.exports = __webpack_public_path__ + "img/IMG_9512_L_WoodMatted.6ea61354.jpg";